import { useMemo } from 'react';

import { useJurisdictionStore } from '@/hooks/use-jurisdiction';

const DEFAULT_NON_NAVIGABLE_CATEGORIES = ['top 10', 'featured', 'recently played'] as const;

/**
 * Returns the list of casino categories that should be hidden from the top navigation.
 *
 * Managed in Prismic via a `list` slice (item_title `non_navigable_categories`) on the casino Product document,
 * combined with a default list of categories (case-insensitive, deduplicated).
 */
export const useNonNavigableCategories = (): readonly string[] => {
    const nonNavigableCategories = useJurisdictionStore(
        state => state.jurisdictionSettings?.productConfig?.nonNavigableCategories
    );
    return useMemo(
        () => [
            ...new Set(
                [...DEFAULT_NON_NAVIGABLE_CATEGORIES, ...(nonNavigableCategories ?? [])].map(category =>
                    category.toLowerCase()
                )
            ),
        ],
        [nonNavigableCategories]
    );
};
